import styled, { css } from 'styled-components';

import { breakpoints, CONTAINER_SIDE_PADDINGS } from '@shared/constants';

export const LayoutContent = styled.div`
    display: grid;
    grid-template-columns: 1fr 375px;
    position: relative;
    width: 100%;

    @media (max-width: ${breakpoints.md}px) {
        bottom: 0;
        grid-template-columns: auto;
        grid-template-rows: auto 1fr auto;
        left: 0;
        position: fixed;
        top: 0;
    }
`;

export const ContentWrapper = styled.div`
    display: flex;
    flex: 1;
    height: 100vh;
    justify-content: center;
    overflow-y: auto;
    padding: 72px 16px 24px;
    position: sticky;
    top: 0;

    @media (max-width: ${breakpoints.md}px) {
        padding: 16px;
        position: static;
        height: 100%;
    }
`;

export const ContentInnerWrapper = styled.div`
    max-width: 750px;
    width: 100%;
    height: 100%;

    // padding hack for overflow scroll
    &::after {
        content: '';
        display: block;
        height: 24px;
    }
`;

export const SidebarWrapper = styled.div`
    height: 100%;

    @media (max-width: ${breakpoints.md}px) {
        order: -1;
    }
`;

export const MobileMenuWrapper = styled.div(
    ({ theme: { palette } }) => css`
        align-items: center;
        background-color: ${palette.neutral.white};
        border-top: 1px solid ${palette.neutral.dividers};
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: ${CONTAINER_SIDE_PADDINGS.xs}px;
        width: 100%;
    `,
);

export const MobileMenuInnerWrapper = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 12px;
    max-width: 458px;
    width: 100%;
`;
